import { SurveyTypesEnum } from "@shared/enums";

export const SurveyCategoriesConst = [
    {id: SurveyTypesEnum.GENERAL, label: 'General'},
    {id: SurveyTypesEnum.ORG_ENVIRONMENT, label: 'Clima Organizacional'},
    {id: SurveyTypesEnum.IMPROVEMENTS_PROPOSALS, label: 'Propuestas de mejoras'},
    {id: SurveyTypesEnum.FIELD_WORK, label: 'Trabajo de campo'},
]